/* eslint-disable no-prototype-builtins */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable guard-for-in */

import { FormField, FormField2, IDynamicFormValue } from 'src/lib';
import _, { keys } from 'lodash';
import { ISkuSelectedDetails, ISkuObject } from '../types/sku-popup-model';

// function to check if value is number,float,exponential or not
function containsNumbers(str) {
  return /^[-+]?\d+(\.\d+)?([eE][-+]?\d+)?$/.test(str);
}

/* eslint-disable no-restricted-syntax */
export function getFormattedSkuObject(
  skuObj: IDynamicFormValue,
  skuDetailsObj: any,
  moduleValue = null
) {
  let skuObjFormatted = JSON.parse(JSON.stringify(skuObj));
  /**
   * check if type is array
   *  inside it check if type is multiselect,
   *    if yes, return array
   *    else, return string
   * else type is not array
   *  return string
   */

  skuObjFormatted = skuDetailsObj.reduce(
    (result, obj) => {
      if (
        Array.isArray(skuObjFormatted[obj.name]) &&
        !_.isEmpty(skuObjFormatted[obj.name])
      ) {
        if (obj.control_type === 'MULTISELECT-DROPDOWN') {
          result[obj.name] = skuObjFormatted[obj.name].map((e) =>
            e.value.trim()
          );
        } else if (obj.name === 'implement_after') {
          result[obj.name] = Number(
            skuObjFormatted[obj.name].map((e) => e.value.slice(1)).join(',')
          );
        } else {
          const currentInputValue = skuObjFormatted[obj.name]
            .map((e) => e.value)
            .join(',');
          // eslint-disable-next-line no-restricted-globals
          result[obj.name] = isNaN(currentInputValue)
            ? currentInputValue
            : Number(currentInputValue);
        }
      } else if (
        !_.isEmpty(skuObjFormatted[obj.name]) ||
        skuObjFormatted[obj.name]
      ) {
          // eslint-disable-next-line no-restricted-globals
          result[obj.name] = isNaN(skuObjFormatted[obj.name])
          ? skuObjFormatted[obj.name]
          : Number(skuObjFormatted[obj.name]); 
      } else {
        if(obj.section === 'manual_overwrite' || obj.section === 'sim_result') {
          result[obj.name] = '';
        } else {
          // setting empty values to empty string/zero
          result[obj.name] = obj.dtype === 'STRING' ? '' : 0;
        }
      }
      return result;
    },
    {
      is_new_parent: false
    }
  );

  // adding module id value in case of edit sku operation
  if (moduleValue) {
    skuObjFormatted.module = moduleValue;
  }

  // adding the is_new_parent key as per the toggle value
  if (skuObj.ppgToggle) {
    skuObjFormatted.is_new_parent = true;
  }
  // else {
  //   skuObjFormatted.is_new_parent = false;
  // }

  return skuObjFormatted;
}

// function for getting sku row details in formatted for duplicating sku
export function getFormattedDuplicatedSku(row, skuDetailsObj: ISkuObject[]) {
  // getting table row object
  let currSkuObj = row;

  currSkuObj = skuDetailsObj.reduce((result, obj) => {
    if (obj.name in currSkuObj) {
      if (obj.control_type === 'MULTISELECT-DROPDOWN') {
        result[obj.name] = currSkuObj[obj.name]
          ? currSkuObj[obj.name].split(',').map((e) => e.trim())
          : '';
      } else {
        result[obj.name] = currSkuObj[obj.name];
      }
    }

    return result;
  }, {});

  return currSkuObj;
}

// function for filtering objects by given keys
function filterObjectByKeys(obj, keysToCheck) {
  return Object.keys(obj).reduce((result, key) => {
    if (keysToCheck.includes(key)) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

// function for comparing objects
function areObjectsEqual(obj1, obj2) {
  for (const key in obj1) {
    // trimming to compare the whole stringw without any spaces
    if (typeof obj1[key] === 'string' && typeof obj2[key] === 'string') {
      const sortedArr1 = obj1[key]
        .split(',')
        .sort((a, b) =>
          a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
        );
      const sortedArr2 = obj2[key]
        .split(',')
        .sort((a, b) =>
          a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
        );
      if (sortedArr1.length !== sortedArr2.length) {
        return false;
      }
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i].trim() !== sortedArr2[i].trim()) {
          return false;
        }
      }
    } else if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
}

// function to detect identical skus in array and adding isIdentical key to the row
export function detectIdenticalObjects(arr, keysToCheck) {
  let tableArray = JSON.parse(JSON.stringify(arr));

  // variable to check is table contains identical rows or not
  let isTableValid = true;

  // returning false in case of empty table data
  if (arr.length === 0) {
    return {
      isTableValid: false,
      tableArray
    };
  }

  // setting isIdentical false in all rows
  for (let row of tableArray) {
    row.parent.data.isIdentical = false;
  }

  // checking if table as only single row left, then delete the isIdentical key if exists
  if (arr.length === 1) {
    delete tableArray[0].parent.data.isIdentical;
    // checking if any row contains incomplete data
    if (tableArray[0].parent.data.is_incomplete) {
      isTableValid = false;
    }
    return { tableArray, isTableValid };
  }

  // // iterating all the rows of table
  for (let i = 0; i < tableArray.length; i++) {
    const obj1: any = filterObjectByKeys(
      tableArray[i].parent.data,
      keysToCheck
    );

    for (let j = 0; j < tableArray.length; j++) {
      const obj2: any = filterObjectByKeys(
        tableArray[j].parent.data,
        keysToCheck
      );

      if (i !== j) {
        // checking for identical objects setting isIdentical to true
        if (areObjectsEqual(obj1, obj2)) {
          tableArray[i].parent.data.isIdentical = true;
          tableArray[j].parent.data.isIdentical = true;
          // if any 2 rows are identical, updating isTableValid to false
          isTableValid = false;
        } else {
          // updating rows to false only if they are not detected as duplicated in previous iteration to maintain the identical state
          tableArray[i].parent.data.isIdentical =
            tableArray[i].parent.data.isIdentical || false;
          tableArray[j].parent.data.isIdentical =
            tableArray[j].parent.data.isIdentical || false;
        }
      }
    }
    // checking if any row contains incomplete data
    if (tableArray[i].parent.data.is_incomplete) {
      isTableValid = false;
    }
  }

  return { tableArray, isTableValid };
}

// function for getting payload for bulk duplicate
export function getBulkDuplicatePayload(bulkDuplicateMap: {
  new_skus_data: object;
  existing_skus_data: object;
}) {
  // preparing payload as per section
  let bulkDuplicatePayload: any = Object.keys(bulkDuplicateMap).map((e) => ({
    [e]: Object.keys(bulkDuplicateMap[e]).map((ele) => ({
      sku: ele,
      count: bulkDuplicateMap[e][ele],
      is_new_sku: e === 'new_skus_data'
    }))
  }));

  bulkDuplicatePayload = {
    new_skus: bulkDuplicatePayload.filter(
      (e) => Object.keys(e)[0] === 'new_skus_data'
    )[0].new_skus_data,
    existing_skus: bulkDuplicatePayload.filter(
      (e) => Object.keys(e)[0] === 'existing_skus_data'
    )[0].existing_skus_data
  };

  return bulkDuplicatePayload;
}

// generic sort function for integers, strings and alphanumeric array values
export function alphanumericSort(arr) {
  const tempArray = [...arr];
  return tempArray.sort((a, b) => {
    // extracting the values of dropdown values
    const valueA = a.label ? a.label : a.alias;
    const valueB = b.label ? b.label : b.alias;
    // Determine the data type of the elements
    const typeA = typeof valueA;
    const typeB = typeof valueB;

    // Handle string comparison
    if (typeA === 'string' && typeB === 'string') {
      const matchedA = valueA.match(/^[^\d]*\d+$/);
      const matchedB = valueB.match(/^[^\d]*\d+$/);

      if (matchedA !== null && matchedB !== null) {
        // extracting number part from string in case of alphanumeric values
        const numA = parseInt(matchedA[0], 10);
        const numB = parseInt(matchedB[0], 10);

        // comparing the numeric values
        if (numA > numB) {
          return 1;
        }
        if (numA < numB) {
          return -1;
        }

        return 0;
      }

      // if numeric values are equal, comparing the whole string
      if (valueA > valueB) {
        return 1;
      }
      if (valueA < valueB) {
        return -1;
      }

      return 0;
    }

    // Handle integer comparison
    if (typeA === 'number' && typeB === 'number') {
      return valueA - valueB;
    }

    // default comparison
    if (valueA > valueB) {
      return 1;
    }
    if (valueA < valueB) {
      return -1;
    }

    return 0;
  });
}

export function alphanumericSort2(arr) {
  let tempArray = [...arr];
  tempArray.sort((a, b) => {
    // getting the keys
    const key1 = a.label ? 'label' : 'alias';
    const key2 = b.label ? 'label' : 'alias';
    return +a[key1].match(/\d+/)[0] - +b[key2].match(/\d+/)[0];
  });

  return tempArray;
}
